import { useQueryApi } from '@gaddario98/react-core/queries'
import type { User } from '@shared'

/**
 * Loads the application profile after Firebase has restored a valid session.
 * This is application bootstrap infrastructure, not a route page: it must be
 * available before any PageGenerator-backed feature reads `userDataState`.
 */
export function useAuthenticatedUser(userId: string, isLogged: boolean) {
  return useQueryApi<User>({
    endpoint: ['users', userId],
    queryKey: [`users/${userId}`],
    enabled: Boolean(userId && isLogged),
    refetchOnWindowFocus: false,
  })
}
